export const environment = {
  duuUploadBucket : 'bridge-qa-bucket-duu-zip-upload',
  identityPoolId:  'us-east-2:99872568-729f-41b6-ac4d-ff00b09b40f8',
  s3_endpoint: '',
  sts_endpoint: '',
  s3_downUrl: 'https://s3.amazonaws.com',
  appVersion: 'Version 1.0.0',
  baseUrl: 'https://api.qa.bridge.lumino.smith-nephew.com',
  baseUrlClp: 'https://api.qa.bridge.lumino.smith-nephew.com',
  baseUrlClpSnn: 'https://api-snn.qa.bridge.lumino.smith-nephew.com',
  baseUnauthUrl: 'https://api2.qa.bridge.lumino.smith-nephew.com',
  userPoolAwsLogin:  'cognito-idp.us-east-2.amazonaws.com/us-east-2_GpdfNzCW1',
  production: true,
  lensSenderEmail: 'snnoreply@maildrop.cc',
  destinationBucket: 'cup-dev-lumino',
  region: 'us-east-2',
  apiVersionCognito: '2016-04-18',
  apiVersionSqs: '2012-11-05',
  lambdaFunction: {
    bridgeDuuProcessZipUpload: 'bridge-qa-duu-process-zip-upload',
    lambdaRegion: 'us-east-2',
  },
  ssmParams: {
    IDLETIME : "/bridge-qa/image-upload-service_qa/inactivityTime_login",
    DIACOMTAG : "/bridge-qa/image-upload-service_qa/validDicomTags",
    RECALLTIME : "/bridge-qa/image-upload-service_qa/recallTime",
    AUDITINTERVALTIME : "/bridge-qa/image-upload-service_qa/auditInterval",
    APPVERSION: "/bridge-qa/image-upload-service_qa/appVersionInfo",
  	APPDIACOMTAGSCRIPT : "/bridge-qa/image-upload-service_qa/validApplicationDicomTags",
    SQSQUEUEURL: "/bridge-qa/DUU_Group_by_patient/group-by-patient-queue-url",
  },

  //ALL ROLES EXPECT SNN
  clp: {
    hostedUIUrl: "https://bridge-qa-clp-auth.auth.us-east-2.amazoncognito.com/oauth2/",
    hostedUIlogout: "https://bridge-qa-clp-auth.auth.us-east-2.amazoncognito.com/logout",
    identityPoolId: "us-east-2:99872568-729f-41b6-ac4d-ff00b09b40f8",
    userPoolId: "us-east-2_GpdfNzCW1",
    userPoolWebClientId: "3u1ehbv6l82u0q5ekd7qtosmc5",
    userPoolAwsLogin: "cognito-idp.us-east-2.amazonaws.com/us-east-2_GpdfNzCW1",
    cloudfrontCLPURL: 'https://clp.qa.bridge.lumino.smith-nephew.com',
    cloudFrontCLPSignInUrl: 'https://clp.qa.bridge.lumino.smith-nephew.com/signin',
    cloudFrontCLPSignOutUrl: 'https://clp.qa.bridge.lumino.smith-nephew.com/logout',
    cloudFrontCLPExitAppUrl: 'https://clp.qa.bridge.lumino.smith-nephew.com/application/product',
  },
  //SNN ROLE
  snnClp: {
    hostedUIUrl: "https://bridge-qa-snn-auth.auth.us-east-2.amazoncognito.com/oauth2/",
    hostedUIlogout: "https://bridge-qa-snn-auth.auth.us-east-2.amazoncognito.com/logout",
    identityPoolId: "us-east-2:b844d63c-065a-4284-a92b-22561a9cafca",
    userPoolId: "us-east-2_qWg7j1GY1",
    userPoolWebClientId: "1o78nobrih22in2euju5qhiqer",
    userPoolAwsLogin: "cognito-idp.us-east-2.amazonaws.com/us-east-2_qWg7j1GY1",
    cloudfrontCLPURL: 'https://snn.qa.bridge.lumino.smith-nephew.com',
    cloudFrontCLPSignInUrl: 'https://snn.qa.bridge.lumino.smith-nephew.com/signin',
    cloudFrontCLPSignOutUrl: 'https://snn.qa.bridge.lumino.smith-nephew.com/logout',
    cloudFrontCLPExitAppUrl: 'https://snn.qa.bridge.lumino.smith-nephew.com/application/product',
  },
  duuCloudFrontSigninUrl: 'https://duu.qa.bridge.lumino.smith-nephew.com/signin',
};
